import React from 'react';

import { Box, ButtonGroup } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const DocuSignReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  const useBearerToken = useWatch({
    control: formControl,
    name: 'properties.useBearerToken',
    defaultValue: false,
  });

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="docuSignReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="docuSignReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="docuSignReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="docuSignReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.parameterizedBy?.message}
      />
      <FormField
        controlId="docuSignReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.format?.message}
      />
      <FormField
        controlId="docuSignReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.connectionKey?.message}
      />
      <FormField
        controlId="docuSignReaderFormDebug"
        label="debug"
        name="properties.debug"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="docuSignReaderFormUseBearerToken"
        label="useBearerToken"
        name="properties.useBearerToken"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      {!useBearerToken && (
        <>
          <FormField
            controlId="docuSignReaderFormUsername"
            label="username"
            name="properties.username"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Username"
            required
            error={errors.properties?.username?.message}
          />
          <FormField
            controlId="docuSignReaderFormPassword"
            label="password"
            name="properties.password"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            type="password"
            placeholder="Enter Password"
            required
            error={errors.properties?.password?.message}
          />
        </>
      )}
      <FormField
        controlId="docuSignReaderFormBasePath"
        label="basePath"
        name="properties.basePath"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.basePath?.message}
      />
      <FormField
        controlId="docuSignReaderFormIntegratorKey"
        label="integratorKey"
        name="properties.integratorKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.integratorKey?.message}
      />
      <FormField
        controlId="docuSignReaderFormAccountId"
        label="accountId"
        name="properties.accountId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.accountId?.message}
      />
      <FormField
        controlId="docuSignReaderFormResourceType"
        label="resourceType"
        name="properties.resourceType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.resourceType?.message}
      />
      <FormField
        controlId="docuSignReaderFormFromDate"
        label="fromDate"
        name="properties.fromDate"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.DATE}
        error={errors.properties?.fromDate?.message}
      />
      <FormField
        controlId="docuSignReaderFormEnvelopeIds"
        label="envelopeIds"
        name="properties.envelopeIds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.envelopeIds?.message}
      />
      <FormField
        controlId="docuSignReaderFormTransactionIds"
        label="transactionIds"
        name="properties.transactionIds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.transactionIds?.message}
      />
      <FormField
        controlId="docuSignReaderFormFolderIds"
        label="folderIds"
        name="properties.folderIds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.folderIds?.message}
      />
      <FormField
        controlId="docuSignReaderFormInclude"
        label="include"
        name="properties.include"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.include?.message}
      />
      <FormField
        controlId="docuSignReaderFormSearchText"
        label="searchText"
        name="properties.searchText"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.searchText?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default DocuSignReaderForm;
